export const TIME_TO_SALE_FETCH_REQUEST = 'TIME_TO_SALE_FETCH_REQUEST'
export const TIME_TO_SALE_FETCH_SUCCESS = 'TIME_TO_SALE_FETCH_SUCCESS'
export const TIME_TO_SALE_FETCH_FAILURE = 'TIME_TO_SALE_FETCH_FAILURE'
